import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SystemMessage } from '../../../core/system-message/system-message-service';
import { MOUVm } from '../../generated/Administration/Models/Events/MOUVm';
import { EventMouVm } from '../../generated/Administration/Models/Events/EventMouVm';

@Injectable({
	providedIn: 'root'
})
export class MouService {
	
	mouLanguageUrl: string = `api/Administration/MOU/GetMOULanguage?id=`;
	mouSaveAckUrl: string = `api/Account/MouAcknowledgement?id=`;
	mouUrl: string = `api/Administration/MOU/GetMOULanguageByEventAndUser?id=`;

	constructor(private httpClient: HttpClient) {}

	getModel(id: number): Observable<MOUVm> { 
		return this.httpClient.get<MOUVm>(`${this.mouLanguageUrl}${id}`); 
	}

	saveAcknowledgement(userId: number, eventId: number): Observable<SystemMessage> {
		return this.httpClient.get<SystemMessage>(`${this.mouSaveAckUrl}${userId}&eventId=${eventId}`);
	}

	getMOULanguageByEventAndUser(id: number, userId: number): Observable<EventMouVm> { 
		return this.httpClient.get<EventMouVm>(`${this.mouUrl}${id}&userId=${userId}`); 
	}
}
